<div class="registration-container">
  <div class="registration-card row g-0">
    <!-- Brand Section -->
    <div class="col-lg-5 brand-section">
      <div class="brand-logo">
        <div class="logo-icon">
          <i class="bi bi-shop"></i>
        </div>
        <div class="brand-title">Become an SmartSeller</div>
      </div>

      <ul class="benefits-list">
        <li>
          <i class="bi bi-people"></i>
          <span>Reach millions of buyers</span>
        </li>
        <li>
          <i class="bi bi-graph-up"></i>
          <span>Grow your business 3x faster</span>
        </li>
        <li>
          <i class="bi bi-shield-lock"></i>
          <span>Secure payment processing</span>
        </li>
        <li>
          <i class="bi bi-headset"></i>
          <span>Dedicated seller support</span>
        </li>
        <li>
          <i class="bi bi-lightning"></i>
          <span>Quick onboarding process</span>
        </li>
      </ul>

    </div>

    <!-- Form Section -->
    <div class="col-lg-7 form-section">
      <div class="form-header">
        <h1 class="form-title">Create Your Seller Account</h1>
        <p class="form-subtitle">Join thousands of successful sellers in just 2 minutes</p>
      </div>

      <form id="registrationForm">
        <!-- Mobile Verification -->
        <div class="form-group">
          <label class="form-label required">Mobile Number</label>
          <div class="input-group">
            <i class="bi bi-phone"></i>
            <input type="tel"
                   id="mobile"
                   class="form-control"
                   placeholder="Enter 10-digit mobile number"
                   maxlength="10"
                   [(ngModel)]="user.mobile"
                   name="mobile">
            <button type="button" class="btn-verify" id="verifyBtn" (click)="checkMobile()" [disabled]="isCheckingMobile">
              {{ isCheckingMobile ? 'Checking...' : 'Verify' }}
            </button>
            <div class="verified-badge" id="verifiedBadge" *ngIf="mobileVerified">
              <i class="bi bi-check-circle"></i> Verified
            </div>
          </div>
        </div>

        <!-- OTP Section -->
        <div class="otp-container" id="otpSection" *ngIf="showOtpSection">
          <div class="otp-header">
            <div class="otp-title">Enter 5-digit OTP sent to <span id="mobileNumber">{{ user.mobile }}</span></div>
            <button type="button" class="otp-resend" id="resendBtn" (click)="requestOtp()" [disabled]="otpTimer > 0">
              <i class="bi bi-arrow-repeat"></i> {{ otpTimer > 0 ? 'Resend in ' + otpTimer + 's' : 'Resend' }}
            </button>
          </div>

          <div class="otp-inputs">
            <input type="text" class="otp-input text-black" maxlength="1" [(ngModel)]="otp[0]" name="otp0" (keyup)="onOtpKeyUp($event, 0)" (paste)="onOtpPaste($event)">
            <input type="text" class="otp-input text-black" maxlength="1" [(ngModel)]="otp[1]" name="otp1" (keyup)="onOtpKeyUp($event, 1)" (paste)="onOtpPaste($event)">
            <input type="text" class="otp-input text-black" maxlength="1" [(ngModel)]="otp[2]" name="otp2" (keyup)="onOtpKeyUp($event, 2)" (paste)="onOtpPaste($event)">
            <input type="text" class="otp-input text-black" maxlength="1" [(ngModel)]="otp[3]" name="otp3" (keyup)="onOtpKeyUp($event, 3)" (paste)="onOtpPaste($event)">
            <input type="text" class="otp-input text-black" maxlength="1" [(ngModel)]="otp[4]" name="otp4" (keyup)="onOtpKeyUp($event, 4)" (paste)="onOtpPaste($event)">
          </div>

          <div class="otp-timer" id="timer">OTP expires in {{ Math.floor(otpTimer / 60).toString().padStart(2, '0') }}:{{ (otpTimer % 60).toString().padStart(2, '0') }}</div>
          <button type="button" class="btn-submit" (click)="verifyOtp()" style="margin-top: 16px;">Verify OTP</button>
        </div>

        <!-- Registration Fields (hidden until mobile verified) -->
        <div id="registrationFields" *ngIf="mobileVerified">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="form-label required">First Name</label>
                <div class="input-group">
                  <i class="bi bi-person"></i>
                  <input type="text" class="form-control" placeholder="Your first name" [(ngModel)]="user.firstName" name="firstName">
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="form-label">Last Name</label>
                <div class="input-group">
                  <i class="bi bi-person"></i>
                  <input type="text" class="form-control" placeholder="Your last name" [(ngModel)]="user.lastName" name="lastName">
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label required">Email Address</label>
            <div class="input-group">
              <i class="bi bi-envelope"></i>
              <input type="email" class="form-control" placeholder="your.email@example.com" [(ngModel)]="user.email" name="email">
            </div>
          </div>

          <div class="form-group">
            <label class="form-label required">Create Password</label>
            <div class="input-group">
              <i class="bi bi-lock"></i>
              <input [type]="showPassword ? 'text' : 'password'" id="password" class="form-control" placeholder="Create a strong password" [(ngModel)]="user.password" name="password" (input)="calculatePasswordStrength()">
              <i class="bi" [class.bi-eye]="!showPassword" [class.bi-eye-slash]="showPassword"
                 id="togglePassword" style="left: auto; right: 16px; cursor: pointer;"
                 (click)="togglePasswordVisibility()"></i>
            </div>

            <div class="password-meter">
              <div class="password-strength" id="passwordStrength" [style.width.%]="passwordStrength"></div>
            </div>

            <div class="password-requirements">
              <div class="requirement" [class.valid]="hasMinLength" id="reqLength">
                <i class="bi" [class.bi-x-circle]="!hasMinLength" [class.bi-check-circle]="hasMinLength"></i>
                <span>At least 8 characters</span>
              </div>
              <div class="requirement" [class.valid]="hasLowerCase" id="reqLower">
                <i class="bi" [class.bi-x-circle]="!hasLowerCase" [class.bi-check-circle]="hasLowerCase"></i>
                <span>Lowercase letter</span>
              </div>
              <div class="requirement" [class.valid]="hasUpperCase" id="reqUpper">
                <i class="bi" [class.bi-x-circle]="!hasUpperCase" [class.bi-check-circle]="hasUpperCase"></i>
                <span>Uppercase letter</span>
              </div>
              <div class="requirement" [class.valid]="hasNumber" id="reqNumber">
                <i class="bi" [class.bi-x-circle]="!hasNumber" [class.bi-check-circle]="hasNumber"></i>
                <span>Contains a number</span>
              </div>
            </div>
          </div>

          <div class="smart-seller-toggle">
            <label class="toggle-switch">
              <input type="checkbox" id="smartSellerToggle" [(ngModel)]="wantsToBeSmartSeller" name="smartSeller">
              <span class="toggle-slider"></span>
            </label>
            <div>
              <div class="toggle-label">Become a Smart Seller</div>
              <div class="toggle-description">Get premium features to grow your business</div>
            </div>
          </div>

          <button type="submit" class="btn-submit" id="submitBtn" (click)="register()" [disabled]="isLoading">
            {{ isLoading ? 'Creating Account...' : 'Create Account' }}
          </button>
        </div>
      </form>

      <div class="login-link">
        Already have an account? <a href="javascript:void(0)" (click)="login()">Sign In</a>
      </div>
    </div>
  </div>
</div>
